<template>
	<div >
		<div style="text-align: center;">
			<!--	<p ><span style="font-family: 宋体; font-size: 12.5pt; font-weight: bold">☆☆☆☆☆☆</span></p>-->
				<p><span style="font-family: 宋体; font-size: 23px; font-weight: bold">专利咨询服务</span></p>
			</div>
			
			<Row>
				<Col span="6">
					<Card style="margin: 20px;" v-for="(item,i) in splitData.data0" :key="i">
		                <p slot="title">{{i*4+1}}、{{item.title}}</p>
		                <p>{{item.body}}</p>
		            </Card>
				</Col>
				<Col span="6">
					<Card style="margin: 20px;" v-for="(item,i) in splitData.data1" :key="i">
		                <p slot="title">{{i*4+2}}、{{item.title}}</p>
		                <p>{{item.body}}</p>
		            </Card>
				</Col>
				<Col span="6">
					<Card style="margin: 20px;" v-for="(item,i) in splitData.data2" :key="i">
		                <p slot="title">{{i*4+3}}、{{item.title}}</p>
		                <p>{{item.body}}</p>
		            </Card>
				</Col>
				<Col span="6">
					<Card style="margin: 20px;" v-for="(item,i) in splitData.data3" :key="i">
		                <p slot="title">{{i*4+4}}、{{item.title}}</p>
		                <p>{{item.body}}</p>
		            </Card>
				</Col>
				
			</Row>

	</div>
</template>

<script>
	export default {
		name: 'metalcertificate',
		data:function(){
			return {
				data:[
					{title:'新颖性检索',body:'向客户提供其目标技术方案是否具备新颖性和创造性的结论，以及得出结论的证据和理由，以便作为客户在决策或相关活动中的重要参考资料。'},
					{title:'优先审查检索',body:'用于办理发明、实用新型专利申请的加快审查检索。出具检索报告，并提供检索出的最相关专利文献全文。'},
					{title:'科技查新检索',body:'根据客户提交的含有具体查新点的技术方案，进行检索和分析，出具有依据、有分析、有对比、有结论的查新报告，并提供纸件的对比文献的全文。'},
					{title:'有效性检索',body:'搜寻审查过程中的疏漏和影响专利性的现有技术，评价专利授权是否正当，该检索通常针对专利侵权或市场商机。出具检索报告，并提供检索出的最相关专利文献全文。'},
					{title:'侵权检索',body:'服务内容包括防止侵权检索和被动侵权检索。用来判断一件可执行的专利的权利要求书是否主张了与委托方的创意或非专利技术相同的技术主题。为客户出具检索报告，并提供检索出的最相关专利文献全文。'},
					{title:'专题检索',body:'对某企业或某技术进行世界范围的专利检索，每次检索需要根据检索委托方的目标制定检索范围，出具检索报告，并提供检索出的最相关专利文献全文。'},
					{title:'跟踪检索',body:'对某技术、某企业的国内外专利进行定期检索，并提供检索出的相关专利的全文，使客户实时掌握最新的专利信息，了解相关技术的发展动向。'},
					{title:'企业/公司/研究机构专利分析',body:'检索各个国家及地区专利信息，对客户关注对象进行专利情报跟踪，使客户及时并准确掌握竞争对手的技术动态，为客户制定技术及市场竞争策略提供参考。'},
					{title:'行业/技术专利分析',body:'检索各个国家及地区专利信息，分析指定行业/技术重点专利及专利权人，描绘（重点）技术发展路线，使客户全面、准确把握该行业/技术研究热点、空白点及风险点，为客户制定技术研发策略提供参考。'},
					{title:'专利地图分析',body:'检索各个国家及地区专利信息，进行剖析整理，制成各种直观图表，使其具备类似地图的指向功能，总结分析技术分布及发展态势，监视竞争对手专利技术动向，帮助客户进行知识产权管理和技术创新管理。'},
					{title:'专利挖掘及布局',body:'从专利整体布局的高度出发，专利挖掘有助于全方位考虑利用核心专利和外围专利相互结合进行申请布局。通过专利挖掘，可以尽早发现竞争对手的威胁专利，便于企业及早进行规避设计以规避专利风险。'},
					{title:'产品专利预警分析',body:'检索各个国家及地区专利信息，根据客户待研发或入市产品的技术特点，研究目标市场相关专利布局情况，分析侵权风险，拟定规避策略，保障客户产品的顺利开发及销售。'},
					{title:'专利导航',body:'以产业或企业相关产品的专利信息为基础，围绕产业宏观层面的规划决策，为企业专利运营提供方向指引和平台环境，指引企业创新路径和专利布局，是宏观规划决策进一步落实的具体举措。'},
					{title:'专利分析评议',body:'通过对相关技术领域的专利信息进行检索和分析，掌握竞争对手该领域专利布局，规避专利侵权风险，把握技术发展路线，选择技术突破方向，从而为科技进步、产业规划和政府决策提供客观依据。'},
					{title:'专利专题库建设',body:'专利专题数据库是针对特定领域的专业特点和用户特色需求，从海量初级专利信息数据中筛选，并进行一定程度的加工所形成的数据库。具有专业领域专利信息集中、全面、信息挖掘程度高、检索方便等优点，有利于使用者学习、借鉴他人的专利发明，提高科技创新的起点和层次。'}
				],
				
				splitData:{
					data0:[],
					data1:[],
					data2:[],
					data3:[],
				}
			};
		},
		created:function(){
			for(var i=0;i<this.data.length;i++){
				var index = "data"+i%4;
				this.splitData[index].push(this.data[i]);
			}
		},
		components: {
		},
		methods:{
			downloadHzd:function(){
				window.location.href = "/static/metalcertificate/hz.doc";
			}
		}
	}
</script>

<style >
	.show-lst .ivu-card-body{
		padding: 20px !important;
		color: #4D5669;
	}
	
	.show-lst .ivu-card-head p{
		color: #7070DD;
	}
</style>


// WEBPACK FOOTER //
// src/view/retrieval/retrieval.vue